import { Box } from '@chakra-ui/react';

import { TextRegular } from 'UiKit/typography';

import styles from './styles.module.css';
import { useNavigate } from 'react-router-dom';
import { Condition, Iteration } from 'Component/others';
import SkeletonComponent from 'UiKit/skeleton';

const Breadcrumb = ({ items = [], isLoading }) => {
  const navigate = useNavigate();

  return (
    <Box className={styles['breadcrumb__container']}>
      <Condition statement={!isLoading} fallback={<SkeletonComponent height="22px" width="300px" />}>
        <Iteration
          items={items}
          render={(item, index) => {
            const title = item?.title ?? '-';
            const link = item.href;

            return (
              <Condition
                key={index}
                statement={index !== items.length - 1}
                fallback={<TextRegular className={styles['breadcrumb__current-page']}>{title}</TextRegular>}
              >
                <Box className={styles['breadcrumb__parent-container']} onClick={() => navigate(link)}>
                  <TextRegular className={styles['breadcrumb__parent-page']}>{title}</TextRegular>
                  <TextRegular className={styles['breadcrumb__separator']}>/</TextRegular>
                </Box>
              </Condition>
            );
          }}
        />
      </Condition>
    </Box>
  );
};

export default Breadcrumb;
